var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.766493 8C0.973934 8 1.15488 7.92662 1.30641 7.78127L6.99851 1.85006L12.6906 7.78127C12.8436 7.92662 13.0231 8 13.2306 8C13.438 8 13.6175 7.92662 13.7705 7.78127C13.9235 7.63451 14 7.45528 14 7.24784C14 7.0404 13.925 6.84989 13.7705 6.68337L7.52227 0.220144C7.39133 0.073381 7.21772 -1.79945e-07 6.99998 -1.6091e-07C6.78224 -1.41875e-07 6.6072 0.0733811 6.47626 0.220144L0.228044 6.68337C0.0765094 6.84989 -2.20243e-07 7.03899 -1.97876e-07 7.24784C-1.75509e-07 7.4567 0.0765095 7.63451 0.228044 7.78127C0.381049 7.92662 0.560525 8 0.767965 8L0.766493 8Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOpen);
export default __webpack_public_path__ + "static/media/arrow-open.9d61c22e231fdfbc539048cbbe695334.svg";
export { ForwardRef as ReactComponent };